import { render, staticRenderFns } from "./storyoftheReserve.vue?vue&type=template&id=492e4132"
import script from "./storyoftheReserve.vue?vue&type=script&lang=js"
export * from "./storyoftheReserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports